import { ActivatedRoute, Params, Router } from '@angular/router';
import { CommonConstants } from './../utilities/commonConstants';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { ClevertapEventHandlerService } from './clevertap-event-handler.service';
@Injectable({
    providedIn: 'root'
})
// The Caller has to call this in its context
export class RouteContextProvider {
    constructor(public _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _location: Location,
        public _clevertapEventHandlerService: ClevertapEventHandlerService
        ) {
        // super(_router);
    }
    // Invoke via call method
    public GetRouteParams(key: string): string {
        let result;
        this._activatedRoute.params.forEach((params) => {
            result = params[key] || CommonConstants.DEFAULT_EMPTY_STRING;
        });
        return result;
    }

    // Invoke via call method
    public GetQueryParams(key: string): string {
        let result;
        this._activatedRoute.queryParams.forEach((params) => {
            result = params[key] || CommonConstants.DEFAULT_EMPTY_STRING;
        });
        return result;
    }

    public GetAllQueryParams(): Observable<Params> {
        return this._activatedRoute.queryParams;
    }

    public NavigateToView(viewKey: any, target?: string): void {
        target ? window.open(viewKey, target) : this._router.navigate(viewKey, { queryParamsHandling: 'preserve' });
        this.triggerPageViewEvent();
    }

    public NavigateToViewWithQueryParams(viewKey: any, params: any) {
        this._router.navigate(viewKey, { queryParams: params });
        this.triggerPageViewEvent();
    }

    public GoBack(): void {
        this._location.back();
    }

    triggerPageViewEvent() {
        setTimeout(() => {
          const varAuthType = window["varAuthType"];
          this._clevertapEventHandlerService.cleverTapEventPush("page_view", {
            page_url: document.URL,
            authType: varAuthType,
          });
        }, 2000);
    }

    // Remove query params from the URL
    removeQueryParams() {
        this._router.navigate(
            [],
            {
                queryParams: {
                    src: null,
                    SS_1: null,
                    SS_2: null,
                    loanApplicationId: null,
                    processId: null,
                    insProductType: null,
                    utm_source: null,
                    utm_medium: null,
                    utm_campaign: null,
                    utm_content: null,
                    utm_term: null,
                    sourceType: null,
                    sessionId: null,
                    categoryCode: null,
                    mobileNo: null,
                    registrationNumber: null,
                    corporateFlag: null,
                    utmSource: null,
                    customerName: null,
                },
                queryParamsHandling: 'merge',
            }
        );
    }
}
